<template>
  <el-container style="width: 100%;height: 100%;display: flex;flex-direction: column;">
    <el-row style="width: 100%; height: 48px;margin-bottom: 1px;background-color: #ffffff;">
      <el-menu default-active="1" class="horizontal-menu" @select="menuSelect"
               mode="horizontal" unique-opened background-color="rgba(0, 0, 0, 0)" text-color="rgba(0, 0, 0, 1)">
        <template v-for="sub in energyItem">
          <el-menu-item class="horizontal-menu-item" :key="sub.id" :index="sub.id">
            <span style="font-size: 14px;">{{sub.name}}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-row>
    <el-row style="width: 100%;height: calc(100% - 49px);display: flex;flex-direction: row;">
      <el-aside style="height: 100%;width: 250px;margin-right: 1px;background-color: #ffffff;">
        <el-row class="doc-tree-top">
          <el-input style='width: 100%; border: none; outline: none' class="filter-search" placeholder="输入关键字搜索" prefix-icon="zy-icon-search" v-model="filterName"/>
        </el-row>
        <el-tree :data="treeData" :props="defaultProps" :filter-node-method="filterNode" node-key='id'
                 :default-expanded-keys="expandKeys" ref="tree" class="aside-tree" show-checkbox :default-checked-keys="checkedKey">
          <span slot-scope="{ node, data }">
            <i v-if="node.data.type === '1'" class="zy-icon-building"></i>
            <i v-if="node.data.type === '2'" class="zy-icon-commit"></i>
            <i v-if="node.data.type === '3'" class="zy-icon-sensor"></i>
            <span>{{ node.label }}</span>
          </span>
        </el-tree>
      </el-aside>
      <el-main style="overflow-y: hidden;font-size: 14px;width: calc(100% - 251px);height: 100%;background-color: #ffffff;">
        <el-row class="tt-input" style="width: 100%;height: 48px;line-height: 48px;color: rgb(127, 127, 127);text-align: left;">
          <span style="margin-left: 24px;">时间：</span>
          <el-radio-group v-model="radio" @change="selBack" style="margin-left: 8px;" size="small">
            <el-radio-button label="年"></el-radio-button>
            <el-radio-button label="月"></el-radio-button>
            <el-radio-button label="日"></el-radio-button>
          </el-radio-group>
          <el-date-picker v-model="monthDate" style="width: 140px;margin-left: 16px" :type="type"
                          placeholder="选择日期" :value-format="format" :clearable="false"/>
          <el-button class="search-btn-blue" style="margin-left: 16px;" @click="getChartData" type="primary" size="mini">查询</el-button>
        </el-row>
        <el-row style="background-color: #fff;width: 100%; height: 1px;"></el-row>
        <el-row style="overflow-y: auto;height: calc(100% - 49px);width: 100%;">
          <el-row style="height: calc(50% - 1px);width: 100%;">
            <el-row style="background-color: rgba(2, 124, 247, 0.8);width: 100%; height: 48px;">
              <span v-if="isMulti" style="text-align: left;height: 48px;line-height: 48px;margin-left: 24px;color: rgb(247, 247, 247);display: flex;">数据曲线</span>
              <span v-else style="text-align: left;height: 48px;line-height: 48px;margin-left: 24px;color: rgb(247, 247, 247);display: flex;">同比</span>
            </el-row>
            <common-charts :init-options="initOptions" class="electric-parameter-charts"
                           :index="200" :key="timestamp" :options="sameData" autoresize :style="{'height': ((bgSize.height - 255) / 2) + 'px', 'width': (bgSize.width - 452) + 'px'}" />
          </el-row>
          <el-row style="height: 1px;width: 100%;background-color: #FFF" />
          <el-row style="height: calc(50% - 1px);width: 100%;" class="table">
            <el-row style="background-color: rgba(2, 124, 247, 0.8);width: 100%; height: 48px;">
              <span v-if="isMulti" style="text-align: left;height: 48px;line-height: 48px;margin-left: 24px;color: rgb(247, 247, 247);display: flex;">分析 (建议选择负载类似的监测点进行比较，有利于排查异常能耗点)</span>
              <span v-else style="text-align: left;height: 48px;line-height: 48px;margin-left: 24px;color: rgb(247, 247, 247);display: flex;">环比</span>
            </el-row>
            <el-table v-if="isMulti" border fit :data="tableData" height="calc(100% - 48px)" width="100%" ref="tableData">
              <el-table-column v-for="(item,i) in tableProps" :key="i+tableData"
                               :prop="item.prop" :label="item.unit ? item.label + '(' + unit + ')' : item.label" :sortable="item.sortable" :width="item.width">
              </el-table-column>
            </el-table>
            <common-charts v-else :init-options="initOptions1" class="electric-parameter-charts"
                           :index="201" :key="timestamp" :options="monthData" autoresize :style="{'height': ((bgSize.height - 255) / 2) + 'px', 'width': (bgSize.width - 452) + 'px'}" />
          </el-row>
        </el-row>
      </el-main>
    </el-row>
  </el-container>
</template>

<script>
import DateUtils from "../../../utils/DateUtils";
import CommonCharts from "../../common/chart/CommonCharts";
import buildCommonConfig from "../../../config/chart/config_common_line";
export default {
  name: "SegStatistics",
  components: {CommonCharts},
  data() {
    return {
      radio: '日',
      initOptions: {
        renderer: 'canvas'
      },
      initOptions1: {
        renderer: 'canvas'
      },
      timestamp: 0,
      chartData: {},
      circleData: {},
      lineData: {},
      selNode: '',
      treeData: [],
      expandKeys: [],
      defaultProps: {
        children: 'childNode',
        label: 'name'
      },
      type: 'date',
      dateType: 1,
      startDate: DateUtils.getYesterday().Format('yyyy-MM'),
      monthDate: new Date().Format('yyyy-MM-dd'),
      format: 'yyyy-MM-dd',
      energyItem: [{'id': '1', 'name': '电'}, {'id': '2', 'name': '水'}, {'id': '11', 'name': '气'}, {'id': '12', 'name': '汽'}],
      bgSize: {'width': window.innerWidth, 'height': window.innerHeight},
      filterName: '',
      unit: 'kWh',
      media: '1',
      tableProps: [
        {prop: "dataName", label: "表计", sortable: false},
        {prop: "energySum", label: "总用量", sortable: true, unit: 1},
        {prop: "energyAvg", label: "平均用量", sortable: true, unit: 1}
      ],
      tableData: [],
      checkedKey: '',
      isMulti: false,
      monthData: {},
      sameData: {}
    }
  },
  created() {
    this.getTree('1')
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.bgSize.width = window.innerWidth
      this.bgSize.height = window.innerHeight
      this.timestamp = new Date().getTime()
    })
  },
  watch: {
    filterName(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    menuSelect(val) {
      this.tableData = []
      this.chartData = []
      this.timestamp = new Date().getTime();
      this.media = val
      this.getTree(val)
      if (val === '1') {
        this.unit = 'kWh'
      } else {
        this.unit = 'm³'
      }
    },
    getTree(val) {
      this.$api.systemManage.getSensorTree(val).then(res => {
        this.treeData = res.data
        if (this.treeData && this.treeData.length > 0) {
          this.selNode = this.getLeafNode(this.treeData[0]);
          this.checkedKey = this.selNode.id.split(',')
          this.$refs.tree.setCheckedKeys([this.selNode['id']], true)
          let nodeIdName = 'id';
          this.$nextTick(function () {
            this.setTreeCurrent(this.selNode[nodeIdName], 1);
            this.getChartData()
          })
        }
      })
    },
    getLeafNode(pNode) {
      let leafNode = pNode;
      if (pNode.childNode && pNode.childNode.length > 0) {
        leafNode = this.getLeafNode(pNode.childNode[0]);
      }
      return leafNode;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data['name'].indexOf(value) !== -1;
    },
    setTreeCurrent(key, time) {
      if (time > 10) throw new Error('没有找到 树组件');
      let tree = this.$refs.tree;
      if (tree) {
        tree.setCurrentKey(key);
        this.expandKeys.push(key);
        let node = tree.getNode(key);
        if (key !== -1) tree.$emit("node-click", node.data, node, tree);
      } else {
        this.setTreeCurrent(key, time + 1)
      }
    },
    selBack(val) {
      if(val === '年') {
        this.dateType = 3
        this.type = 'year'
        this.monthDate = new Date().Format('yyyy')
        this.format = 'yyyy'
      }
      if(val === '月') {
        this.dateType = 2
        this.type = 'month'
        this.monthDate = new Date().Format('yyyy-MM')
        this.format = 'yyyy-MM'
      }
      if(val === '日') {
        this.dateType = 1
        this.type = 'date'
        this.monthDate = new Date().Format('yyyy-MM-dd')
        this.format = 'yyyy-MM-dd'
      }
      this.getChartData()
    },
    getChartData() {
      if (this.$refs.tree.getCheckedKeys().length === 1) {
        this.isMulti = false;
        let params = {'id': this.$refs.tree.getCheckedKeys().join(","), 'energy': this.media, 'dataDate': this.monthDate, 'dateType': this.dateType}
        this.$api.energyAnalyse.getEnergyCurveByType(params).then(res => {
          let xAxis = res.data[0].dataTime
          let data = []
          let legend = res.data[0].itemList
          res.data[0].curveList.forEach((sd) => {
            data.push({
              name: sd.dataName,
              type: 'bar',
              data: sd.dataData.split(",")
            })
          })
          this.sameData = buildCommonConfig(legend, xAxis, data, 0, this.unit);
          this.show = false
          if (res.data.length >= 2) {
            let data1 = []
            this.show = true
            let legend1 = res.data[1].itemList
            res.data[1].curveList.forEach((sd) => {
              data1.push({
                name: sd.dataName,
                type: 'bar',
                data: sd.dataData.split(",")
              })
            })
            this.monthData = buildCommonConfig(legend1, xAxis, data1, 0, this.unit);
          } else {
            this.monthData = {}
          }
          this.timestamp = new Date().getTime();
        })
      } else if (this.$refs.tree.getCheckedKeys().length > 1) {
        this.isMulti = true;
        let params = {'id': this.$refs.tree.getCheckedKeys().join(","), 'energy': this.media, 'dataDate': this.monthDate, 'dateType': this.dateType}
        this.tableData = []
        this.$api.energyAnalyse.getEnergyCompare(params).then(res => {
          let xAxis = res.data.dataTime
          let data = []
          let legend = res.data.itemList
          res.data.curveList.forEach((sd) => {
            data.push({
              name: sd.dataName,
              type: 'bar',
              data: sd.dataData.split(",")
            })
            this.tableData.push({
              energySum: sd.energySum,
              energyAvg: sd.energyAvg,
              dataName: sd.dataName
            })
          })
          this.sameData = buildCommonConfig(legend, xAxis, data, 'dataMin', this.unit);
          this.timestamp = new Date().getTime();
        })
      }
    }
  }
}
</script>

<style scoped>
  .doc-tree-top{
    display: inline-flex;
    align-items: center;
    height: 49px;
    width: 250px;
    border-bottom: 1px solid #fff;
  }
  .electric-parameter-charts{
    width: 100%;
    margin-top: 0;
  }
  .new-electric-parameter-charts{
    width: 100%;
    padding: 0;
  }
  /*.table /deep/ .el-table tr {*/
  /*  background-color: transparent!important;*/
  /*}*/
  .table /deep/ .el-table th {
    background-color: rgba(2, 124, 247, 0.2);
    border-top: 0;
  }
  /*.table /deep/ .el-table--enable-row-transition .el-table__body td, .el-table .cell{*/
  /*  background-color: transparent;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/EnergyAnalyse/EnergyContrast.vue